import { render, staticRenderFns } from "./editget.vue?vue&type=template&id=a95a1174&scoped=true&"
import script from "./editget.vue?vue&type=script&lang=js&"
export * from "./editget.vue?vue&type=script&lang=js&"
import style0 from "./editget.vue?vue&type=style&index=0&id=a95a1174&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95a1174",
  null
  
)

export default component.exports